<template>
  <div class="room dehumidifier-small" v-loading="loadingData">
    <div class="device-block-multi">
      <div class="device-block" :class="warningFlagLeft">
        <div class="device-block-line-chart">
          <DoubleGraph :opts="humidityLineLeftOpts" :series="humidityLineLeftData"></DoubleGraph>
        </div>
        <div class="device-block-bar-chart">
          <SinglePieHistogramWrap :opts="humidityBarLeftOpts" :series="humidityBarLeftData"></SinglePieHistogramWrap>
        </div>
      </div>

      <div class="device-block" :class="warningFlagRight">
        <div class="device-block-line-chart">
          <DoubleGraph :opts="humidityLineRightOpts" :series="humidityLineRightData"></DoubleGraph>
        </div>
        <div class="device-block-bar-chart">
          <SinglePieHistogramWrap :opts="humidityBarRightOpts" :series="humidityBarRightData"></SinglePieHistogramWrap>
        </div>
      </div>
    </div>

    <div class="device-block-line">
      <div class="device-block-line-item">
        <div class="device-block-line-item-half">
          <SwitchStatus class="switch-item" :title="switchTitleLeftL1" :series="switchDataLeftL1"></SwitchStatus>
          <SwitchStatus class="switch-item" :title="switchTitleLeftL2" :series="switchDataLeftL2"></SwitchStatus>
          <RunningTimeBig class="device-block-time" :title="runningTimeTitleLeftL" :series="runningTimeDataLeftL" :isHour="true"></RunningTimeBig>
        </div>
        <div class="device-block-line-item-half">
          <SwitchStatus class="switch-item" :title="switchTitleLeftR1" :series="switchDataLeftR1"></SwitchStatus>
          <SwitchStatus class="switch-item" :title="switchTitleLeftR2" :series="switchDataLeftR2"></SwitchStatus>
          <RunningTimeBig class="device-block-time" :title="runningTimeTitleLeftR" :series="runningTimeDataLeftR" :isHour="true"></RunningTimeBig>
        </div>
      </div>

      <div class="device-block-line-item">
        <div class="device-block-line-item-half">
          <SwitchStatus class="switch-item" :title="switchTitleRightL1" :series="switchDataRightL1"></SwitchStatus>
          <SwitchStatus class="switch-item" :title="switchTitleRightL2" :series="switchDataRightL2"></SwitchStatus>
          <RunningTimeBig class="device-block-time" :title="runningTimeTitleRightL" :series="runningTimeDataRightL" :isHour="true"></RunningTimeBig>
        </div>
        <div class="device-block-line-item-half">
          <SwitchStatus class="switch-item" :title="switchTitleRightR1" :series="switchDataRightR1"></SwitchStatus>
          <SwitchStatus class="switch-item" :title="switchTitleRightR2" :series="switchDataRightR2"></SwitchStatus>
          <RunningTimeBig class="device-block-time" :title="runningTimeTitleRightR" :series="runningTimeDataRightR" :isHour="true"></RunningTimeBig>
        </div>
      </div>

      <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    </div>
  </div>
</template>

<script>
import configJson from "./config/steelBoxConfig.json";

export default {
  name: "steelBox",
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,
      stationId: "",
      bridgeSegmentName: "",
      deviceNameLeft: "",
      deviceNameRight: "",
      warningFlagLeft: "",
      warningFlagRight: "",
      deviceList: [],
      stationName: "",
      humidityLineLeftData: null,
      humidityBarLeftData: null,
      humidityLineRightData: null,
      humidityBarRightData: null,
      switchDataLeftL1: null,
      switchDataLeftL2: null,
      switchDataLeftL3: null,
      switchDataLeftR1: null,
      switchDataLeftR2: null,
      switchDataLeftR3: null,
      switchDataRightL1: null,
      switchDataRightL2: null,
      switchDataRightR1: null,
      switchDataRightR2: null,
      runningTimeDataLeftL: null,
      runningTimeDataLeftR: null,
      runningTimeDataRightL: null,
      runningTimeDataRightR: null,

      humidityBarOpts: {
        title: "除湿机温湿度",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      },
    };
  },
  computed: {
    humidityLineLeftOpts: function () {
      return {
        title: this.bridgeSegmentName + this.deviceNameLeft + "除湿机温湿度",
        legend1: "除湿机湿度",
        legend2: "除湿机温度",
      };
    },
    humidityBarLeftOpts: function () {
      return {
        title: "除湿机温湿度",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
    humidityLineRightOpts: function () {
      return {
        title: this.bridgeSegmentName + this.deviceNameRight + "除湿机温湿度",
        legend1: "除湿机湿度",
        legend2: "除湿机温度",
      };
    },
    humidityBarRightOpts: function () {
      return {
        title: "除湿机温湿度",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
    switchTitleLeftL1: function () {
      return "除湿机" + this.deviceNameLeft + "运行";
    },
    switchTitleLeftL2: function () {
      return "除湿机" + this.deviceNameLeft + "故障";
    },
    switchTitleLeftR1: function () {
      return "循环风机" + this.deviceNameLeft + "运行";
    },
    switchTitleLeftR2: function () {
      return "循环风机" + this.deviceNameLeft + "故障";
    },
    runningTimeTitleLeftL: function () {
      return "除湿机" + this.deviceNameLeft + "运行时间";
    },
    runningTimeTitleLeftR: function () {
      return "循环风机" + this.deviceNameLeft + "运行时间";
    },
    switchTitleRightL1: function () {
      return "除湿机" + this.deviceNameRight + "运行";
    },
    switchTitleRightL2: function () {
      return "除湿机" + this.deviceNameRight + "故障";
    },
    switchTitleRightR1: function () {
      return "循环风机" + this.deviceNameRight + "运行";
    },
    switchTitleRightR2: function () {
      return "循环风机" + this.deviceNameRight + "故障";
    },
    runningTimeTitleRightL: function () {
      return "除湿机" + this.deviceNameRight + "运行时间";
    },
    runningTimeTitleRightR: function () {
      return "循环风机" + this.deviceNameRight + "运行时间";
    },
  },
  created() {
    this.readConfig();
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.readConfig();
      this.loadingData = true;
      this.getData();
    },
  },
  methods: {
    resetData() {
      this.warningFlagLeft = "";
      this.warningFlagRight = "";
    },
    refreshData() {
      this.loadingData = true;
      this.getData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    readConfig() {
      const routerPath = this.$route.fullPath.split("/");
      const routerName = routerPath[3].toLowerCase();
      this.deviceList = configJson[routerName].deviceList;
      this.bridgeSegmentName = configJson[routerName].bridgeSegmentName;
      this.stationName = configJson[routerName].stationName;
      this.stationId = configJson[routerName].stationId;
      this.deviceNameLeft = configJson[routerName].deviceNameLeft;
      this.deviceNameRight = configJson[routerName].deviceNameRight;
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find((el) => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || "";
    },
    getStatisticsData(deviceId) {
      return this.$http.get("/statistics/DeviceData?deviceId=" + deviceId + "&interval=BY_HOUR&insertBlankData=true");
    },
    getCurrentData(stationId) {
      return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
    },
    getData() {
      this.getLineChartData();

      this.getCurrentData(this.stationId).then((res) => {
        setTimeout(() => {
          this.loadingData = false;
        }, 500);

        const currentData = res.data;

        this.setPieHistogramDataAndError(
          currentData,
          "humidityBarLeftData",
          "除湿机" + this.deviceNameLeft + "温度",
          "除湿机" + this.deviceNameLeft + "湿度",
          "warningFlagLeft"
        );
        this.setPieHistogramDataAndError(
          currentData,
          "humidityBarRightData",
          "除湿机" + this.deviceNameRight + "温度",
          "除湿机" + this.deviceNameRight + "湿度",
          "warningFlagRight"
        );

        const switchIdLeftL1 = this.findDeviceId(this.switchTitleLeftL1);
        const switchIdLeftL2 = this.findDeviceId(this.switchTitleLeftL2);
        const switchIdLeftR1 = this.findDeviceId(this.switchTitleLeftR1);
        const switchIdLeftR2 = this.findDeviceId(this.switchTitleLeftR2);
        this.switchDataLeftL1 = {
          data: currentData[switchIdLeftL1].value,
          isError: currentData[switchIdLeftL1].errorLevel,
        };
        this.switchDataLeftL2 = {
          data: currentData[switchIdLeftL2].value,
          isError: currentData[switchIdLeftL2].errorLevel,
          isZh: true,
        };

        this.switchDataLeftR1 = {
          data: currentData[switchIdLeftR1].value,
          isError: currentData[switchIdLeftR1].errorLevel,
        };
        this.switchDataLeftR2 = {
          data: currentData[switchIdLeftR2].value,
          isError: currentData[switchIdLeftR2].errorLevel,
          isZh: true,
        };

        const switchIdRightL1 = this.findDeviceId(this.switchTitleRightL1);
        const switchIdRightL2 = this.findDeviceId(this.switchTitleRightL2);
        const switchIdRightR1 = this.findDeviceId(this.switchTitleRightR1);
        const switchIdRightR2 = this.findDeviceId(this.switchTitleRightR2);
        this.switchDataRightL1 = {
          data: currentData[switchIdRightL1].value,
          isError: currentData[switchIdRightL1].errorLevel,
        };
        this.switchDataRightL2 = {
          data: currentData[switchIdRightL2].value,
          isError: currentData[switchIdRightL2].errorLevel,
          isZh: true,
        };
        this.switchDataRightR1 = {
          data: currentData[switchIdRightR1].value,
          isError: currentData[switchIdRightR1].errorLevel,
        };
        this.switchDataRightR2 = {
          data: currentData[switchIdRightR2].value,
          isError: currentData[switchIdRightR2].errorLevel,
          isZh: true,
        };

        const runningTimeIdLeftL = this.findDeviceId(this.runningTimeTitleLeftL);
        this.runningTimeDataLeftL = currentData[runningTimeIdLeftL].value;
        const runningTimeIdLeftR = this.findDeviceId(this.runningTimeTitleLeftR);
        this.runningTimeDataLeftR = currentData[runningTimeIdLeftR].value;

        const runningTimeIdRightL = this.findDeviceId(this.runningTimeTitleRightL);
        this.runningTimeDataRightL = currentData[runningTimeIdRightL].value;
        const runningTimeIdRightR = this.findDeviceId(this.runningTimeTitleRightR);
        this.runningTimeDataRightR = currentData[runningTimeIdRightR].value;
      });
    },

    setPieHistogramDataAndError(currentData, echartSeriesDataName, temperatureName, humidityName, warningFlagName) {
      const temperatureId = this.findDeviceId(temperatureName);
      const humidityId = this.findDeviceId(humidityName);
      this[echartSeriesDataName] = {
        data1: currentData[temperatureId].value,
        data2: currentData[humidityId].value,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(currentData[temperatureId].errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(currentData[humidityId].errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getLineChartData() {
      let temperatureDeviceNameL = "除湿机" + this.deviceNameLeft + "温度";
      let humidityDeviceNameL = "除湿机" + this.deviceNameLeft + "湿度";
      this.$http
        .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceNameL)), this.getStatisticsData(this.findDeviceId(humidityDeviceNameL))])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(temperaturePromise, humidityPromise, "humidityLineLeftData", "warningFlagLeft");
          })
        );

      let temperatureDeviceNameR = "除湿机" + this.deviceNameRight + "温度";
      let humidityDeviceNameR = "除湿机" + this.deviceNameRight + "湿度";
      this.$http
        .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceNameR)), this.getStatisticsData(this.findDeviceId(humidityDeviceNameR))])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(temperaturePromise, humidityPromise, "humidityLineRightData", "warningFlagRight");
          })
        );
    },
    setLineData(temperatureData, humidityData, echartSeriesDataName, warningFlagName) {
      let data1 = {};
      let data2 = {};
      temperatureData.data.dataList.forEach((item, index) => {
        data1[item.StatisticsDate] = item.value;
      });
      humidityData.data.dataList.forEach((item, index) => {
        data2[item.StatisticsDate] = item.value;
      });

      this[echartSeriesDataName] = {
        data1: data1,
        data2: data2,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(temperatureData.data.errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(humidityData.data.errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dehumidifier-small {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;

  .device-block-multi {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block {
      width: calc(50% - 10px);
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      position: relative;

      .device-block-line-chart {
        width: 75%;
        height: 100%;
      }

      .device-block-bar-chart {
        width: 24%;
        height: 100%;
      }
    }
  }

  .device-block-line {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block-line-item {
      width: calc(50% - 10px);
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      align-items: stretch;

      .device-block-line-item-top-left {
        display: flex;
        justify-content: space-between;
        height: 140px;
        width: 100%;
      }

      .device-block-line-item-top-right {
        display: flex;
        justify-content: space-between;
        height: 89px;
        width: 100%;
      }

      .device-block-line-item-half {
        display: flex;
        height: 100%;
        width: calc(50% - 7px);
        flex-direction: column;
        justify-content: space-between;
      }

      .switch-item {
        height: 38px;
        width: 100%;
        box-sizing: border-box;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }

      .device-block-time {
        height: calc(100% - 80px);
        width: 100%;
        box-sizing: border-box;
      }
    }
  }
}
</style>
